import { Component, ViewChild, HostListener } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TraslateService } from './traslate.service';
import { environment } from 'src/environments/environment';
import { SliderComponent } from './slider/slider.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterEvent } from '@angular/router';
import { Title } from '@angular/platform-browser';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent {
  @ViewChild(SliderComponent) child;
  title = 'stgDrive';
  url2: string;
  url: any;
  url3: any;
  message:string;
  channel: string;

  isShow: boolean;
  topPosToStartShowing = 100;
  IconUserConnected: any;
  icon: any ='https://app.stgdrive.com/assets/1.16:85/ctx/images/custom/stg/favicon.ico';
  titlePage: any ="STG DRIVE";






  @HostListener('window:scroll')
  checkScroll() {

    // window의 scroll top
    // Both window.pageYOffset and document.documentElement.scrollTop returns the same result in all the cases. window.pageYOffset is not supported below IE 9.

    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

   // //console.log('[scroll]', scrollPosition);

    this.isShow = scrollPosition >= this.topPosToStartShowing && !this.router?.url.includes("newLogin");
  }

  // TODO: Cross browsing
  gotoTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }


  constructor( public translate: TranslateService ,public traslateService: TraslateService ,private spinner: NgxSpinnerService, private router: Router, private titleService:Title) {



    this.router.errorHandler = (error: any) => {
      let routerError = error.toString();
      if (routerError.indexOf('Cannot match any routes') >= 0 ) {
        this.router.navigate(['/404']);

      } else {
         throw error;
      }
  }

    translate.addLangs(['en', 'fr', 'es']);
    const favicon = document.getElementById("favicon");
    this.icon = JSON.parse(localStorage.getItem('currentUser'))?.reseller_icon
    //console.log(this.icon)
    this.titlePage = JSON.parse(localStorage.getItem('currentUser'))?.reseller+" "+JSON.parse(localStorage.getItem('currentUser'))?.company
    document.getElementById('favicon').setAttribute('href', 'https://app.stgdrive.com/assets/1.16:85/ctx/images/custom/stg/favicon.ico');
    this.titleService.setTitle("STG DRIVE");

    if (JSON.parse(localStorage.getItem('currentUser'))?.role != 'Admin') {
      document.getElementById('favicon').setAttribute('href', this.icon);
      this.titleService.setTitle(this.titlePage+" DRIVE");
    }

    if(JSON.parse(localStorage.getItem('currentUser'))?.role == null)  {
      document.getElementById('favicon').setAttribute('href', 'https://app.stgdrive.com/assets/1.16:85/ctx/images/custom/stg/favicon.ico');
      this.titleService.setTitle("STG DRIVE");
    }
/*     this.router.events.subscribe((event : RouterEvent) => {
      //  this.navigationInterceptor(e);
        switch (true) {
          case event instanceof NavigationStart: {
            this.spinner.show();
            break;
          }
          case event instanceof NavigationEnd :
          case event instanceof NavigationCancel :
          case event instanceof NavigationError : {
            setTimeout(() => {
             this.spinner.hide();
            }, 100);
            break;
          }
          default: break;
        }
      }); */





    }

  ngOnInit(): void {


    this.traslateService.sharedMessage.subscribe(channel => {
      this.translate.setDefaultLang(localStorage.getItem("langue")?.split('_')[0]);
    });
  }

  switchLang(lang: string) {
    this.translate.use(lang);
  }


}


// console.log = function () {};
// console.warn = function () {};
// console.error = function () {};

